<template>
  <div class="full" >
    <div id="map" class="full"/>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'google-map-only-current',
  props: {
    selectedSpotType: { type: String }
  },
  computed: {
    ...mapState(['search', 'currentLat', 'currentLng'])
  },
  data () {
    return {
      mapName: 'map',
      element: null,
      latlng: null,
      mapOptions: null,
      map: null,
      markers: [],
      selectedId: null,
      departureLatLng: undefined,
      destinationLatLng: undefined,
      currentMarker: undefined
    }
  },
  methods: {
    ...mapMutations([
      'loadingStart',
      'loadingEnd',
      'setDepLatLng',
      'setDesLatLng',
      'loadingStartMini',
      'loadingEndMini'
    ]),
    /**
     * マップのロード
     */
    loadMap () {
      this.element = document.getElementById(this.mapName)
      this.latlng = new window.google.maps.LatLng(this.currentLat, this.currentLng)
      this.mapOptions = {
        zoom: 12,
        center: this.latlng,
        gestureHandling: 'greedy',
        scaleControl: false,
        mapTypeControl: false,
        zoomControl: true,
        streetViewControl: false,
        fullscreenControl: false
      }
      this.map = new window.google.maps.Map(this.element, this.mapOptions)
      const trafficLayer = new window.google.maps.TrafficLayer()
      trafficLayer.setMap(this.map)
    },
    /**
     * マーカーのセット
     */
    setMarker (position) {
      this.currentMarker = new window.google.maps.Marker({
        position,
        map: this.map
      })

      this.loadingEndMini()
    },
    getGeo (text, dep) {
      const re = new RegExp('^[0-9]{1,3}.[0-9]*.* [0-9]{1,3}.[0-9]*')
      if (re.test(text)) {
        const coord = new RegExp('([0-9]{1,3}.[0-9]*)', 'g')
        let parsedString = text.match(coord)
        let latlng = new window.google.maps.LatLng(parsedString[0], parsedString[1])
        if (dep) {
          this.setDepLatLng(latlng)
        } else {
          this.setDesLatLng(latlng)
        }
        return
      }
      if (text === '現在地') {
        let latlng = new window.google.maps.LatLng(this.currentLat, this.currentLng)
        if (dep) {
          this.setDepLatLng(latlng)
        } else {
          this.setDesLatLng(latlng)
        }
        return
      }
      var setDepLatLng = this.setDepLatLng
      var setDesLatLng = this.setDesLatLng
      var loadingEnd = this.loadingEnd
      var geocoder = new window.google.maps.Geocoder()
      geocoder.geocode({
        address: text
      }, function (results, status) {
        if (status === window.google.maps.GeocoderStatus.OK) {
          // eslint-disable-next-line
          for (var i in results) {
            if (results[0].geometry) {
              var latlng = results[0].geometry.location
              if (dep) {
                setDepLatLng(latlng)
              } else {
                setDesLatLng(latlng)
              }
            }
          }
        } else if (status === window.google.maps.GeocoderStatus.ZERO_RESULTS) {
          let tex = '目的地'
          if (dep) {
            tex = '出発地'
          }
          alert(tex + 'が見つかりませんでした')
          loadingEnd()
        } else {
          alert('GooleMapで場所情報取得中にエラーが発生しました')
        }
      })
    },
    convertAndSetSpot (text, isDeparture) {
      const re = new RegExp('^[0-9]{1,3}.[0-9]*.* [0-9]{1,3}.[0-9]*')
      if (re.test(text)) {
        const coord = new RegExp('([0-9]{1,3}.[0-9]*)', 'g')
        let parsedString = text.match(coord)
        var latlng = new window.google.maps.LatLng(parsedString[0], parsedString[1])
        if (isDeparture) {
          this.setMarker(latlng, true)
          this.searchNearby(latlng)
        }
        return latlng
      }
      this.getGeo(text, isDeparture)
      return text
    }
  },
  mounted () {
    this.loadingStartMini()
    if (this.currentLat && this.currentLng) {
      this.loadMap()
    }
  },
  watch: {
    map: {
      immideate: true,
      handler: function () {
        this.setMarker(new window.google.maps.LatLng(this.currentLat, this.currentLng))
      }
    },
    currentLat: {
      immideate: true,
      handler: function () {
        this.loadMap()
        this.setMarker(new window.google.maps.LatLng(this.currentLat, this.currentLng))
      }
    },
    search: {
      immideate: true,
      handler: function () {
        if (this.search) {
          this.getGeo(this.search.departure, true)
          this.getGeo(this.search.destination, false)
        }
      }
    }
  }
}
</script>

<style scoped>
.google-map {
  width: 100%;
  height: 100px;
  margin: 0 auto;
  background: gray;
}
.full{
  width:100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Organisms/GoogleMapOnlyCurrent.vue